// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1bBXq","content":"styles_content__3PU7-"};